module.exports = __webpack_public_path__ + "img/icon-map-pin.8c60a8d7.svg";